var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6623 3.57595L17.4341 3.73859L17.4537 4.01818C17.4645 4.17136 17.4647 4.3274 17.4647 4.50553C17.4647 9.54716 13.6235 15.3307 6.59986 15.4964L6.28894 15.4968C4.83047 15.4989 3.39294 15.2186 2.05569 14.6791C3.62602 14.4877 5.12214 13.8785 6.37856 12.907L7.50236 12.038L6.08206 12.0115C4.81231 11.9878 3.67538 11.3149 3.04844 10.2787C3.44371 10.2757 3.8381 10.2224 4.22169 10.1192L4.18936 9.14601C2.75676 8.86105 1.67258 7.76744 1.37928 6.41484C1.78829 6.54496 2.2153 6.61809 2.64792 6.63081L4.41054 6.68261L2.93744 5.71333C1.56084 4.80755 1.01599 3.12602 1.52373 1.64135C3.67261 3.92498 6.64919 5.30061 9.8247 5.45689L10.4884 5.48956L10.3359 4.8428C10.0469 3.61647 10.4411 2.32975 11.3759 1.46474L11.376 1.4647C12.8286 0.120279 15.1157 0.189873 16.4802 1.6183L16.6689 1.81582L16.937 1.76377C17.3789 1.678 17.8124 1.55873 18.234 1.40747C17.9919 1.67549 17.7079 1.90822 17.3898 2.09571L17.7014 3.02312C17.9671 2.99228 18.231 2.94935 18.4921 2.89457C18.2322 3.13969 17.955 3.3674 17.6623 3.57595Z",
    fill: "#A8C956",
    stroke: "#A8C956"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.abc208c1332ac7129615645db3357197.svg";
export { ForwardRef as ReactComponent };